import api from './api';

class InstantMeetingService {

  create(mails, language) {
    return api.post("meetings/instant", { mails: mails, language: language }).then(response => {
        return response.data;
      })
  }

  get(key) {
    return api.get(`meetings/instant/client/${key}`).then(response => {
        return response.data;
    })
  }

}

export default new InstantMeetingService();
